import { render, staticRenderFns } from "./ContentEditSimple.vue?vue&type=template&id=6f651c39&scoped=true&"
import script from "./ContentEditSimple.vue?vue&type=script&lang=js&"
export * from "./ContentEditSimple.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditSimple.vue?vue&type=style&index=0&id=6f651c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f651c39",
  null
  
)

export default component.exports